module.exports = __webpack_public_path__ + "img/error-notification.9900b468.svg";